import {
  UserLoginResDto,
  UserLoginDto,
  UserRefreshTokenDto,
  UserRefreshTokenResDto,
  UserChangePasswordDto,
  SaasAdminSetPasswordDto,
  SaasAdminSetPasswordResDto,
} from '@docbay/schemas';
import axiosInstance from './axiosInstance';
import axiosTokenInstance from './axiosTokenInstance';

/**
 * UsersAPI class for handling user-related API calls.
 */
export const UsersAPI = {
  /**
   * Logs in a user and returns the login response.
   *
   * @param data - The user login data.
   * @returns A promise that resolves to the user login response.
   */
  usersLogin: (data: UserLoginDto) =>
    axiosTokenInstance().post<UserLoginResDto>('/users/login', data),

  /**
   * Refreshes a user's access token and returns the refresh token response.
   *
   * @param data - The user refresh token data.
   * @returns A promise that resolves to the user refresh token response.
   */
  usersRefreshToken: (data: UserRefreshTokenDto) =>
    axiosTokenInstance().post<UserRefreshTokenResDto>(
      '/users/refresh-token',
      data,
    ),

  /**
   * Signs out a user.
   *
   * @returns A promise that resolves to the logout response.
   */
  signOut: () => axiosInstance.post('/users/logout'),

  /**
   * Changes the password for a SaaS user.
   *
   * @param data - The user change password data.
   * @returns A promise that resolves to the change password response.
   */
  changePasswordSaas: (data: UserChangePasswordDto) =>
    axiosInstance.post('/saas/change-password', data),

  /**
   * Creates a new SaaS admin password.
   *
   * @param data - The SaaS admin set password data.
   * @returns A promise that resolves to the set password response.
   */
  createPassword: (data: SaasAdminSetPasswordDto) =>
    axiosInstance.post<SaasAdminSetPasswordResDto>('/saas/password', data),
};
